import * as tslib_1 from "tslib";
import AmCharts from "../AmCharts";
import cx from 'classnames';
import * as React from 'react';
import { disableZeroValues, getGroupedData, normalizeDataLabels, sortPieChartDataByValue } from './utils/pieChart';
import Styles from "./Charts.css";
import { DEFAULT_SETTINGS, LEGEND_SETTINGS, RESPONSIVE_SETTINGS } from './constants';
import Utils from './utils/common';

var PieChart =
/** @class */
function (_super) {
  tslib_1.__extends(PieChart, _super);

  function PieChart() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.getOptions = function () {
      var _a = _this.props,
          title = _a.title,
          data = _a.data,
          // unit,
      legendPosition = _a.legendPosition,
          alignLegend = _a.alignLegend,
          pieColor = _a.pieColor,
          // pieLabelText,
      pieLabelRadius = _a.pieLabelRadius,
          donut = _a.donut,
          innerRadius = _a.innerRadius,
          timeRange = _a.timeRange,
          disableDownload = _a.disableDownload,
          legendEnabled = _a.legendEnabled,
          responsive = _a.responsive; // should be removed after AN-2526 implementation -->

      var TEMPORARY = data.data.map(function (d, ind) {
        if (ind === 0) {
          return tslib_1.__assign({}, d, {
            color: '#ff0f00'
          });
        }

        if (ind === 1) {
          return tslib_1.__assign({}, d, {
            color: '#04d215'
          });
        }

        return d;
      });
      var sortedData = sortPieChartDataByValue(TEMPORARY); // <---should be removed after AN-2526 implementation
      // const sortedData = sortPieChartDataByValue(data.data);

      var normalizedData = normalizeDataLabels(sortedData);
      var dataProvider = getGroupedData(normalizedData);

      var options = tslib_1.__assign({}, DEFAULT_SETTINGS, {
        type: 'pie',
        sequencedAnimation: true,
        titleField: 'title',
        valueField: data.meta.valueField || 'value',
        colorField: 'color',
        startDuration: 0,
        labelRadius: pieLabelRadius || 5,
        labelsEnabled: false,
        color: pieColor || '#333333',
        dataProvider: dataProvider,
        balloonText: '[[title]]: [[percents]]% ([[value]])',
        labelText: '[[value]]',
        labelWidth: 5,
        maxLabelWidth: 5,
        precision: -1,
        listeners: [{
          event: 'dataUpdated',
          method: disableZeroValues
        }]
      });

      if (donut) {
        options.innerRadius = innerRadius || 60;
      } // ------------------------------
      // Legend
      // ------------------------------


      if (legendEnabled) {
        options.legend = tslib_1.__assign({}, LEGEND_SETTINGS, {
          enabled: legendPosition !== 'none',
          align: alignLegend || 'left',
          equalWidths: true,
          horizontalGap: 10
        });

        if (data.meta.legend) {
          options.legend.data = data.meta.legend;
        }
      } // ------------------------------
      // Responsive
      // ------------------------------


      if (responsive) {
        options.responsive = tslib_1.__assign({}, RESPONSIVE_SETTINGS, {
          enabled: true
        });
      } // ------------------------------
      // Export
      // ------------------------------


      if (!disableDownload) {
        options.export = Utils.getExportOptions(title, timeRange);
      }

      return options;
    };

    return _this;
  }

  PieChart.prototype.render = function () {
    var _a = this.props,
        height = _a.height,
        className = _a.className;

    var style = tslib_1.__assign({}, height ? {
      height: height
    } : {});

    var options = this.getOptions();
    return React.createElement("div", {
      className: cx(Styles.pieChart, className)
    }, React.createElement(AmCharts.React, {
      style: style,
      options: options
    }));
  };

  return PieChart;
}(React.PureComponent);

export default PieChart;